import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { useIntl } from 'react-intl';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import createValidator from '@htmniseko/htm-validators/utils/createValidator';
import required from '@htmniseko/htm-validators/utils/required';
import EmailField from 'components/Form/FormField/EmailField';
import PasswordField from 'components/Form/FormField/PasswordField';
import SecondaryButton from 'components/Buttons/SecondaryButton';

export const LoginForm = ({ handleSubmit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const intl = useIntl();

  return (
    <form onSubmit={handleSubmit}>
      <EmailField
        id="email"
        name="email"
        hideLabel={isMobile}
        fieldSizeSM={12}
        label={intl.formatMessage({ id: 'page.login.passwordLogin.email' })}
      />
      <PasswordField
        id="password"
        name="password"
        hideLabel={isMobile}
        fieldSizeSM={12}
        label={intl.formatMessage({ id: 'page.login.passwordLogin.password' })}
      />
      <SecondaryButton fullWidth type="submit" variant="contained">
        <Box fontWeight="fontWeightBold">
          <FormattedTranslation id="page.login.passwordLogin.submit" />
        </Box>
      </SecondaryButton>
    </form>
  );
};

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const withReduxForm = reduxForm({
  form: 'login',
  validate: createValidator({ email: [required], password: [required] }),
})(LoginForm);

export default connect(state => ({ initialValues: { email: state.auth.email } }))(withReduxForm);
